(function () {
  // Only pass the product param on internal CTA links.
  // UTMs and click IDs (fbclid, gclid, etc.) are captured by their
  // respective pixels/GA4 on the landing page hit and stored in cookies.
  // Re-appending them to internal links causes GA4 session splitting.
  var params = new URLSearchParams(window.location.search);
  var productHandle = params.get('product');
  if (!productHandle) return;

  // Validate handle format (mirrors nd-personalization-utils.js)
  productHandle = productHandle.trim().toLowerCase();
  if (productHandle.length > 200 || !/^[a-z0-9][-a-z0-9]*$/.test(productHandle)) return;

  var productUrl = '/products/' + productHandle;
  var productChecked = false;
  var productExists = false;

  /**
   * Validate that the product handle resolves to a real product
   * via Shopify's /products/{handle}.js JSON endpoint.
   */
  function validateProduct(callback) {
    if (productChecked) return callback(productExists);
    fetch(productUrl + '.js')
      .then(function (r) {
        productChecked = true;
        productExists = r.ok;
        callback(productExists);
      })
      .catch(function () {
        productChecked = true;
        productExists = false;
        callback(false);
      });
  }

  /**
   * Append ?product= to a link's existing href and mark it for analytics (collection mode).
   */
  function applyCollectionMode(a) {
    var href = a.getAttribute('href');
    try {
      var url = new URL(href, window.location.origin);
      url.searchParams.set('product', productHandle);
      a.setAttribute('href', url.pathname + url.search + url.hash);
    } catch (e) {
      a.setAttribute('href', href + (href.indexOf('?') !== -1 ? '&' : '?') + 'product=' + encodeURIComponent(productHandle));
    }
    a.setAttribute('data-nd-personalized-product', productHandle);
  }

  function rewrite() {
    var links = document.querySelectorAll('a.nd-cta-pill, a.nd-cta-soft, a.vv-cta');
    var productModeLinks = [];

    links.forEach(function (a) {
      var href = a.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) return;

      var mode = a.getAttribute('data-nd-cta-mode') || 'collection';

      if (mode === 'product') {
        productModeLinks.push(a);
      } else {
        applyCollectionMode(a);
      }
    });

    // Product-mode links need async validation before rewriting.
    // We defer both href and data-nd-personalized-product until validation
    // completes to avoid a race where a fast click navigates to the wrong URL.
    if (productModeLinks.length > 0) {
      validateProduct(function (valid) {
        productModeLinks.forEach(function (a) {
          if (valid) {
            a.setAttribute('href', productUrl);
            a.setAttribute('data-nd-personalized-product', productHandle);
          } else {
            // Product doesn't exist — fall back to collection mode
            applyCollectionMode(a);
          }
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rewrite);
  } else {
    rewrite();
  }
})();
